export const MENU_AUTH = {
  MENU_SMG: 'MENU_SMG', // 台上见小程序前端管理
  MENU_SMG_VENUE: 'MENU_SMG_VENUE', // 台上见小程序前端管理-点位管理
  MENU_SMG_SHOW: 'MENU_SMG_SHOW', // 台上见小程序前端管理-剧目管理
  MENU_SMG_BIZ: 'MENU_SMG_BIZ', // 台上见小程序前端管理-业态管理
  MENU_SMG_MALL: 'MENU_SMG_MALL', // 台上见小程序前端管理-商城管理

  MENU_PLATFORM: 'MENU_PLATFORM', // 平台数据分析
  MENU_PLATFORM_VISITS: 'MENU_PLATFORM_VISITS', // 平台数据分析-访问规模
  MENU_PLATFORM_PAGE_HEAT: 'MENU_PLATFORM_PAGE_HEAT', // 平台数据分析-小程序页面热度
  MENU_PLATFORM_ENTRY: 'MENU_PLATFORM_ENTRY', // 平台数据分析-访问入口分析

  MENU_SALES: 'MENU_SALES', // 销售分析
  MENU_SALES_BOARD: 'MENU_SALES_BOARD', // 销售分析-票房看板
  MENU_SALES_ORDERS: 'MENU_SALES_ORDERS', // 销售分析-订单管理
  MENU_SALES_MALL: 'MENU_SALES_MALL', // 销售分析-会员商城分析

  MENU_MARKETING: 'MENU_MARKETING', // 营销中心
  MENU_MARKETING_AUDIENCE: 'MENU_MARKETING_AUDIENCE', // 营销中心-营销人群
  MENU_MARKETING_TOOLS: 'MENU_MARKETING_TOOLS', // 营销中心-营销工具
  MENU_MARKETING_ADS: 'MENU_MARKETING_ADS', // 营销中心-广告推广
  MENU_MARKETING_CHANNEL: 'MENU_MARKETING_CHANNEL', // 营销中心-渠道码管理
  MENU_MARKETING_COUPONS: 'MENU_MARKETING_COUPONS', // 营销中心-优惠券中心
  MENU_MARKETING_REACH: 'MENU_MARKETING_REACH', // 营销中心-触达管理

  MENU_MEMBERS: 'MENU_MEMBERS', // 会员中心
  MENU_MEMBERS_MANAGE: 'MENU_MEMBERS_MANAGE', // 会员中心-会员管理
  MENU_MEMBERS_BEHAVIOR: 'MENU_MEMBERS_BEHAVIOR', // 会员中心-会员行为
  MENU_MEMBERS_TAGS: 'MENU_MEMBERS_TAGS', // 会员中心-用户标签
  MENU_MEMBERS_POINTS: 'MENU_MEMBERS_POINTS', // 会员中心-用户积分管理
  MENU_MEMBERS_ORDERS: 'MENU_MEMBERS_ORDERS', // 会员中心-订单管理
  MENU_MEMBERS_LEVELS: 'MENU_MEMBERS_LEVELS', // 会员中心-会员等级权益管理
  MENU_MEMBERS_VIP: 'MENU_MEMBERS_VIP', // 会员中心-888VIP
  MENU_MEMBERS_INSIGHT: 'MENU_MEMBERS_INSIGHT', // 会员中心-会员洞察
  MENU_MEMBERS_COMPLAINTS: 'MENU_MEMBERS_COMPLAINTS', // 会员中心-投诉处理

  MENU_FINANCE: 'MENU_FINANCE', // 财务管理
  MENU_FINANCE_INVOICE: 'MENU_FINANCE_INVOICE', // 财务管理-开票申请导出

  MENU_PERMISSIONS: 'MENU_PERMISSIONS', // 权限中心
  MENU_PERMISSIONS_ADMIN: 'MENU_PERMISSIONS_ADMIN', // 权限中心-超级管理员
  MENU_PERMISSIONS_ROLES: 'MENU_PERMISSIONS_ROLES', // 权限中心-成员权限管理
  MENU_PERMISSIONS_LOGS: 'MENU_PERMISSIONS_LOGS', // 权限中心-操作日志

  MENU_SMG_VENUE_BANNER: 'MENU_SMG_VENUE_BANNER', // 台上见小程序前端管理-点位管理-轮播图管理
  MENU_SMG_VENUE_HOT: 'MENU_SMG_VENUE_HOT', // 台上见小程序前端管理-点位管理-热门推荐管理
  MENU_SMG_VENUE_NEW: 'MENU_SMG_VENUE_NEW', // 台上见小程序前端管理-点位管理-新剧推荐管理
  MENU_SMG_VENUE_THEATER: 'MENU_SMG_VENUE_THEATER', // 台上见小程序前端管理-点位管理-剧场集合页
  MENU_SMG_VENUE_SPLASH: 'MENU_SMG_VENUE_SPLASH', // 台上见小程序前端管理-点位管理-开屏弹窗管理
  MENU_SMG_VENUE_SPLASH_AD: 'MENU_SMG_VENUE_SPLASH_AD', // 台上见小程序前端管理-点位管理-全屏广告
  MENU_SMG_VENUE_PATH: 'MENU_SMG_VENUE_PATH', // 台上见小程序前端管理-点位管理-Path字典
  MENU_SMG_SHOW_LIST: 'MENU_SMG_SHOW_LIST', // 台上见小程序前端管理-剧目管理-剧目列表
  MENU_SMG_SHOW_IMPORT: 'MENU_SMG_SHOW_IMPORT', // 台上见小程序前端管理-剧目管理-剧目导入
  MENU_SMG_SHOW_TICKET: 'MENU_SMG_SHOW_TICKET', // 台上见小程序前端管理-剧目管理-非台上见小程序票根
  MENU_SMG_MALL_GOODS: 'MENU_SMG_MALL_GOODS', // 台上见小程序前端管理-商城管理-商品管理
  MENU_SMG_MALL_SHELF: 'MENU_SMG_MALL_SHELF', // 台上见小程序前端管理-商城管理-货架管理
  MENU_SMG_MALL_EXCHANGE: 'MENU_SMG_MALL_EXCHANGE', // 台上见小程序前端管理-商城管理-礼品兑换记录

  MENU_PLATFORM_VISITS_ENTRY: 'MENU_PLATFORM_VISITS_ENTRY', // 平台数据分析-访问规模-访问入口分析
  MENU_PLATFORM_PAGE_HEAT_TOP5: 'MENU_PLATFORM_PAGE_HEAT_TOP5', // 平台数据分析-小程序页面热度-小程序页面TOP5
  MENU_PLATFORM_PAGE_HEAT_PATH: 'MENU_PLATFORM_PAGE_HEAT_PATH', // 平台数据分析-小程序页面热度-访问路径管理
  MENU_PLATFORM_ENTRY_SCENE: 'MENU_PLATFORM_ENTRY_SCENE', // 平台数据分析-访问入口分析-场景值访问情况

  MENU_SALES_BOARD_REALTIME: 'MENU_SALES_BOARD_REALTIME', // 销售分析-票房看板-实时平台总票房
  MENU_SALES_BOARD_SHOW: 'MENU_SALES_BOARD_SHOW', // 销售分析-票房看板-单一剧目票房管理
  MENU_SALES_BOARD_CHANNEL: 'MENU_SALES_BOARD_CHANNEL', // 销售分析-票房看板-渠道分析
  MENU_SALES_BOARD_REPORT: 'MENU_SALES_BOARD_REPORT', // 销售分析-票房看板-报表中心
  MENU_SALES_ORDERS_PLATFORM: 'MENU_SALES_ORDERS_PLATFORM', // 销售分析-订单管理-台上见订单查询
  MENU_SALES_ORDERS_POOL: 'MENU_SALES_ORDERS_POOL', // 销售分析-订单管理-票池订单查询
  MENU_SALES_MALL_OVERVIEW: 'MENU_SALES_MALL_OVERVIEW', // 销售分析-会员商城分析-商城概览

  MENU_MARKETING_TOOLS_COUPON_ACT: 'MENU_MARKETING_TOOLS_COUPON_ACT', // 营销中心-营销工具-领券活动
  MENU_MARKETING_TOOLS_REPURCHASE: 'MENU_MARKETING_TOOLS_REPURCHASE', // 营销中心-营销工具-复购营销
  MENU_MARKETING_TOOLS_LOTTERY: 'MENU_MARKETING_TOOLS_LOTTERY', // 营销中心-营销工具-抽奖活动
  MENU_MARKETING_TOOLS_EXTRACT: 'MENU_MARKETING_TOOLS_EXTRACT', // 营销中心-营销工具-取数工具
  MENU_MARKETING_TOOLS_SHARE_LOTTERY: 'MENU_MARKETING_TOOLS_SHARE_LOTTERY', // 营销中心-营销工具-分享抽奖
  MENU_MARKETING_TOOLS_AGGREGATION: 'MENU_MARKETING_TOOLS_AGGREGATION', // 营销中心-营销工具-活动聚合页
  MENU_MARKETING_TOOLS_SURVEY: 'MENU_MARKETING_TOOLS_SURVEY', // 营销中心-营销工具-调查问卷
  MENU_MARKETING_TOOLS_ANALYSIS: 'MENU_MARKETING_TOOLS_ANALYSIS', // 营销中心-营销工具-活动分析
  MENU_MARKETING_CHANNEL_GEN: 'MENU_MARKETING_CHANNEL_GEN', // 营销中心-渠道码管理-生成渠道码
  MENU_MARKETING_CHANNEL_TRACK: 'MENU_MARKETING_CHANNEL_TRACK', // 营销中心-渠道码管理-渠道数据追踪
  MENU_MARKETING_COUPONS_MANAGE: 'MENU_MARKETING_COUPONS_MANAGE', // 营销中心-优惠券中心-优惠券管理
  MENU_MARKETING_COUPONS_ISSUE: 'MENU_MARKETING_COUPONS_ISSUE', // 营销中心-优惠券中心-优惠券发放
  MENU_MARKETING_COUPONS_VERIFY: 'MENU_MARKETING_COUPONS_VERIFY', // 营销中心-优惠券中心-优惠券核销
  MENU_MARKETING_COUPONS_DATA: 'MENU_MARKETING_COUPONS_DATA', // 营销中心-优惠券中心-优惠券数据
  MENU_MARKETING_COUPONS_EXCHANGE_VERIFY_DEPT:
    'MENU_MARKETING_COUPONS_EXCHANGE_VERIFY_DEPT', // 营销中心-优惠券中心-兑换券核销部门
  MENU_MARKETING_COUPONS_EXCHANGE_VERIFY_EMPLOYEE:
    'MENU_MARKETING_COUPONS_EXCHANGE_VERIFY_EMPLOYEE', // 营销中心-优惠券中心-兑换券核销人员
  MENU_MARKETING_REACH_MP: 'MENU_MARKETING_REACH_MP', // 营销中心-触达管理-小程序推送
  MENU_MARKETING_REACH_SMS: 'MENU_MARKETING_REACH_SMS', // 营销中心-触达管理-短信发送

  MENU_MEMBERS_MANAGE_POINTS: 'MENU_MEMBERS_MANAGE_POINTS', // 会员中心-会员管理-积分管理
  MENU_MEMBERS_MANAGE_QUERY: 'MENU_MEMBERS_MANAGE_QUERY', // 会员中心-会员管理-会员查询
  MENU_MEMBERS_MANAGE_ADJUST: 'MENU_MEMBERS_MANAGE_ADJUST', // 会员中心-会员管理-会员调整
  MENU_MEMBERS_BEHAVIOR_BOARD: 'MENU_MEMBERS_BEHAVIOR_BOARD', // 会员中心-会员行为-会员看板
  MENU_MEMBERS_BEHAVIOR_ANALYSIS: 'MENU_MEMBERS_BEHAVIOR_ANALYSIS', // 会员中心-会员行为-会员分析
  MENU_MEMBERS_BEHAVIOR_BENEFIT: 'MENU_MEMBERS_BEHAVIOR_BENEFIT', // 会员中心-会员行为-会员权益使用
  MENU_MEMBERS_TAGS_MANAGE: 'MENU_MEMBERS_TAGS_MANAGE', // 会员中心-用户标签-标签库和数据
  MENU_MEMBERS_TAGS_CROWD: 'MENU_MEMBERS_TAGS_CROWD', // 会员中心-用户标签-用户人群圈选
  MENU_MEMBERS_TAGS_COLLECTION: 'MENU_MEMBERS_TAGS_COLLECTION', // 会员中心-用户标签-标签目录整理
  MENU_MEMBERS_INSIGHT_RFM: 'MENU_MEMBERS_INSIGHT_RFM', // 会员中心-会员洞察-RFM分析
};
